<template>
  <div>
    <el-row class="mgb">
      <el-col :span="8">
        <span class="label">收款方</span>
        <span class="value">{{detailData.payee | defaultShow}}</span>
      </el-col>
      <el-col :span="8">
        <span class="label">银行名称</span>
        <span class="value">{{detailData.bankName | defaultShow}}</span>
      </el-col>
      <el-col :span="8">
        <span class="label">银行账号</span>
        <span class="value">{{detailData.bankAccount | defaultShow}}</span>
      </el-col>
    </el-row>
  </div>
</template>

<script>
  export default {
    name: "app-supplier-detail-receive-info",
    props: {
      detailData: null,
    }
  }
</script>

<style scoped>
  .label {
    color: #666;
    display: inline-block;
    width: 82px;
    text-align: right;
    padding-right: 10px;
  }

  .value {
    color: #333;
  }

  .mgb {
    margin-bottom: 20px;
  }
</style>
